module.exports = __webpack_public_path__ + "static/enterprise-bfd9df907172d3aa19ff02f970cacffb.png";